import React, { Component } from "react";

export class Pending extends Component {
  render() {
    return (
      <div>
        <p>
          You have not been authorized! Once you have been approved, you will
          receive an email
        </p>
      </div>
    );
  }
}

export default Pending;
